module.exports = __webpack_public_path__ + "img/6_80.749c06b9.png";